import React, { useState } from 'react'

import ConfirmationDialog from 'components/ConfirmationDialog'
import { ModalInjectedProps } from 'containers/ModalManager'
import { useToast } from 'containers/ToastManager'

import { useDeleteSharePermanentlyMutation } from 'gqlTypes'
import { removeFromPaginated } from 'utils'

export interface DeleteSharePermanentlyModalProps extends ModalInjectedProps {
  name: string
  shareIdentifier: string
  workspaceId: string
}

export const DeleteSharePermanentlyModal: React.FC<DeleteSharePermanentlyModalProps> = props => {
  const { name, hideModal, shareIdentifier, workspaceId, isModalOpen } = props

  const { showToast } = useToast()
  const [success, setSuccess] = useState(false)

  const [deletePermanently, { loading }] = useDeleteSharePermanentlyMutation({
    variables: { workspaceId: workspaceId, shareIdentifier },
    update: cache => {
      removeFromPaginated(
        cache,
        { __typename: 'Share', identifier: shareIdentifier },
        key => key.includes('workspaceTrash')
      )
    },
    onCompleted: () => {
      setSuccess(true)
      showToast(`"${name}" has been permanently deleted`)
      hideModal()
    },
    onError: 'show-toast',
  })

  return (
    <ConfirmationDialog
      title="Delete Document Permanently?"
      isModalOpen={isModalOpen}
      hideModal={hideModal}
      cancelButton={{
        disabled: loading,
      }}
      confirmButton={{
        text: 'Delete Permanently',
        variant: 'negative',
        loading,
        disabled: loading || success,
      }}
      onConfirm={deletePermanently}>
      <p>
        Deleting “<strong>{name}</strong>” permanently will also delete all its
        activity and history across the whole Workspace. This action cannot be
        undone.
      </p>
    </ConfirmationDialog>
  )
}
